/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import LoadingOverlay from "../../../components/Ui/LoadingOverlay";

import AdminChangeEmail from "../../../components/Admin/Setting/ChangeEmail";
import AdminChangePassword from "../../../components/Admin/Setting/ChangePassword";
import GeneralSetting from "../../../components/Admin/Setting/General";

const ManagerSubscription = () => {
  const tabs = {
    general: 1,
    changePassword: 2,
    changeEmail: 3,
  };

  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(tabs.general);

  const activeTabClass = (tab) => {
    return tab === selectedTab ? "bg-indigo-50" : "";
  };

  return (
    <div className="w-full">
      <div className="w-10/12 mx-auto max-w-6xl">
        <div className="lg:col-start-2 col-span-12 lg:col-span-10 grid grid-cols-6 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 mx-auto">
          <div className="p-4 col-span-6 md:col-span-2 ">
            <div className="grid grid-cols-3">
              <div
                onClick={(e) => setSelectedTab(tabs.general)}
                className={`${activeTabClass(
                  tabs.general
                )} md:col-span-3 items-center group relative flex gap-x-6 rounded-lg p-3 text-sm leading-6 hover:bg-indigo-50 mb-1`}
              >
                <div className="text-center flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white mx-auto md:mx-0">
                  <svg
                    className="mx-auto items-center justify-center h-6 w-6 text-gray-600 group-hover:text-indigo-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z"
                    />
                  </svg>
                </div>
                <div className="flex-auto hidden md:block">
                  <a href="#" className="block font-semibold text-gray-900">
                    General
                    <span className="absolute inset-0"></span>
                  </a>
                </div>
              </div>

              <div
                onClick={(e) => setSelectedTab(tabs.changePassword)}
                className={`${activeTabClass(
                  tabs.changePassword
                )} md:col-span-3 group relative flex items-center gap-x-6 rounded-lg p-3 text-sm leading-6 hover:bg-indigo-50 mb-1`}
              >
                <div className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white  mx-auto md:mx-0">
                  <svg
                    className="h-6 w-6 text-gray-600 group-hover:text-indigo-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M7.864 4.243A7.5 7.5 0 0119.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 004.5 10.5a7.464 7.464 0 01-1.15 3.993m1.989 3.559A11.209 11.209 0 008.25 10.5a3.75 3.75 0 117.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 01-3.6 9.75m6.633-4.596a18.666 18.666 0 01-2.485 5.33"
                    />
                  </svg>
                </div>
                <div className="flex-auto  hidden md:block">
                  <a href="#" className="block font-semibold text-gray-900">
                    Change Admin Password
                    <span className="absolute inset-0"></span>
                  </a>
                </div>
              </div>
              <div
                onClick={(e) => setSelectedTab(tabs.changeEmail)}
                className={`${activeTabClass(
                  tabs.changeEmail
                )} md:col-span-3 group relative flex items-center gap-x-6 rounded-lg p-3 text-sm leading-6 hover:bg-indigo-50 mb-1`}
              >
                <div className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white  mx-auto md:mx-0">
                  <svg
                    className="h-6 w-6 text-gray-600 group-hover:text-indigo-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zM12 2.25V4.5m5.834.166l-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243l-1.59-1.59"
                    />
                  </svg>
                </div>
                <div className="flex-auto  hidden md:block">
                  <a href="#" className="block font-semibold text-gray-900">
                    Change Admin Email
                    <span className="absolute inset-0"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 col-span-6 md:col-span-4">
            {selectedTab === tabs.general && (
              <p className="text-lg text-gray-500 dark:text-gray-400">
                <strong className="font-medium text-gray-800 dark:text-white">
                  {/* General content */}
                </strong>
              </p>
            )}
            {selectedTab === tabs.changeEmail && <AdminChangeEmail />}
            {selectedTab === tabs.changePassword && <AdminChangePassword />}

            {selectedTab === tabs.general && <GeneralSetting />}
          </div>
        </div>
      </div>

      {loading && <LoadingOverlay />}
    </div>
  );
};

export default ManagerSubscription;
